import { render, staticRenderFns } from "./Comments.vue?vue&type=template&id=baeec3b2&scoped=true"
import script from "./Comments.js?vue&type=script&lang=js&external"
export * from "./Comments.js?vue&type=script&lang=js&external"
import style0 from "./Comments.scss?vue&type=style&index=0&id=baeec3b2&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baeec3b2",
  null
  
)

export default component.exports